"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unitLabels = void 0;
// const to store unit value that we will be showing in label of fields
exports.unitLabels = {
    lb: 'Lbs',
    qt: 'Qts',
    L: 'Liters',
    g: 'Grams',
    kg: 'KG',
};
exports.default = exports.unitLabels;
//# sourceMappingURL=unitLabels.js.map